export default "__VITE_ASSET__x94MBu1Z__"